import React from 'react'

interface Props {
    state: string | null
}

function CheckIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
            <path d="M2 6.5L5 9.5L11 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

function PlayIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
            <path d="M3.5 2.5L10.5 6.5L3.5 10.5V2.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

function PauseIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
            <line x1="4" y1="2.5" x2="4" y2="10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <line x1="9" y1="2.5" x2="9" y2="10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    )
}

interface StateConfig {
    label: string
    chipClass: string
    icon: React.ReactNode
}

const STATE_MAP: Record<string, StateConfig> = {
    // Cerrado — gris
    full:     { label: 'Cerrado',   chipClass: 'bg-[#F1F5F9] text-[#64748B]', icon: <CheckIcon /> },
    closed:   { label: 'Cerrado',   chipClass: 'bg-[#F1F5F9] text-[#64748B]', icon: <CheckIcon /> },
    cerrado:  { label: 'Cerrado',   chipClass: 'bg-[#F1F5F9] text-[#64748B]', icon: <CheckIcon /> },

    // Procesando — verde
    available:   { label: 'Procesando', chipClass: 'bg-[#DCFCE7] text-[#16A34A]', icon: <PlayIcon /> },
    processing:  { label: 'Procesando', chipClass: 'bg-[#DCFCE7] text-[#16A34A]', icon: <PlayIcon /> },
    procesando:  { label: 'Procesando', chipClass: 'bg-[#DCFCE7] text-[#16A34A]', icon: <PlayIcon /> },

    // Espera — gris
    waiting: { label: 'Espera', chipClass: 'bg-[#F1F5F9] text-[#64748B]', icon: <PauseIcon /> },
    wait:    { label: 'Espera', chipClass: 'bg-[#F1F5F9] text-[#64748B]', icon: <PauseIcon /> },
    espera:  { label: 'Espera', chipClass: 'bg-[#F1F5F9] text-[#64748B]', icon: <PauseIcon /> },
}

export default function SorterChuteStateChip({ state }: Props) {
    if (state === null || state === '') {
        return <span className="text-sm text-[#CBD5E1]">—</span>
    }

    const config = STATE_MAP[state.toLowerCase()]

    if (config === undefined) {
        return (
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-[#F1F5F9] text-[#64748B]">
                {state}
            </span>
        )
    }

    return (
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${config.chipClass}`}>
            {config.icon}
            {config.label}
        </span>
    )
}
